import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { RootState } from '../../../stateStore'
import remittanceApi from '../../../middleware/api/Invoicing/AddBankList/addBankListApi'
import {
  GetRemittanceDetailsType,
  RemittanceDetailsListState,
} from '../../../types/Invoicing/RemittanceDetails/remittanceDetailstype'

const remittance = createAsyncThunk(
  'addBank/remittance',
  async (_, thunkApi) => {
    try {
      return await remittanceApi.remittance()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const addBankType = createAsyncThunk(
  'addBank/addBankType',
  async (name: string, thunkApi) => {
    try {
      return await remittanceApi.addBankType(name)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const deleteBank = createAsyncThunk(
  '/addBank/deleteBank',
  async (bankId: number, thunkApi) => {
    try {
      return await remittanceApi.deleteBank(bankId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const initialaddBankState: RemittanceDetailsListState = {
  getRemittanceDetailsList: {} as GetRemittanceDetailsType,
  getCurrencyList: [],
  isLoading: ApiLoadingState.idle,
}

const addBankSlice = createSlice({
  name: 'addBank',
  initialState: initialaddBankState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        isAnyOf(remittance.pending, addBankType.pending, deleteBank.pending),
        (state) => {
          state.isLoading = ApiLoadingState.loading
        },
      )
      .addMatcher(
        isAnyOf(
          remittance.fulfilled,
          addBankType.fulfilled,
          deleteBank.fulfilled,
        ),
        (state, action) => {
          state.isLoading = ApiLoadingState.succeeded
          state.getRemittanceDetailsList =
            action.payload as GetRemittanceDetailsType
        },
      )
      .addMatcher(isAnyOf(deleteBank.rejected), (state) => {
        state.isLoading = ApiLoadingState.failed
      })
  },
})

const addBankThunk = {
  remittance,
  addBankType,
  deleteBank,
}

const isLoading = (state: RootState): LoadingState =>
  state.addBankList.isLoading
const addBank = (state: RootState): GetRemittanceDetailsType =>
  state.addBankList.getRemittanceDetailsList

const addBankSelectors = {
  isLoading,
  addBank,
}

export const addBankService = {
  ...addBankThunk,
  actions: addBankSlice.actions,
  selectors: addBankSelectors,
}
const addBankReducer = addBankSlice.reducer
export default addBankReducer
